export default function /* @ngInject */ stripeValidateCardBrand($q, stripeLoadSdk, stripeData, stripeConfig) {
    // Warn about unsupported card brands before bothering the Stripe API.
    // https://support.stripe.com/questions/which-cards-and-payment-types-can-i-accept-with-stripe
    // https://stripe.com/docs/stripe.js?#card-cardType
    const SUPPORTED = ['Unknown'].concat(stripeConfig.supportedBrands);
    function link(scope, element, attrs, ngModel) {
        stripeLoadSdk().then((Stripe) => {
            ngModel.$validators.card_brand = function(value) {
                let brand = Stripe.card.cardType(value || '');
                stripeData.brand = brand;
                return SUPPORTED.indexOf(brand) >= 0;
            };
        });
    }
    return {
        require: 'ngModel',
        link: link
    };
}



// WEBPACK FOOTER //
// ./stripe/validators/stripe-validate-card-brand.js